import { Container } from 'hypo-container';
export const getDecorators = (container: Container) => ({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    lazyInject: (name?: string) => (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        target: any,
        key: string,
        descriptor?: PropertyDescriptor
    ) => {
        const resourceName = name || key;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const sbGetter = function (this: any) {
            const resource = container.get(resourceName);
            if (!resource) {
                throw new Error(`The requested ${resourceName} does not exists`);
            }

            return resource;
        };
        let propertyDescriptor = descriptor || {};
        if (!descriptor) {
            propertyDescriptor = {
                get: sbGetter
            };
            Object.defineProperty(target, key, propertyDescriptor);
        } else {
            propertyDescriptor.get = sbGetter;
        }
    }
});
